module.exports = __webpack_public_path__ + "img/se.fd663a70.svg";